import { Link } from "react-router-dom";
import Footer from "../components/Footer";

export default function PrivacyPolicy() {
    return (
        <section className="min-h-screen bg-appBg dark:bg-appDark py-4 px-6">

            <div className="max-w-6xl mx-auto">

                {/* TITLE */}
                <h1 className="text-4xl font-bold mb-8 text-titleLight dark:text-titleDark">
                    Privacy Policy
                </h1>

                {/* DATE */}
                <p className="mb-6 text-subText dark:text-subTextDark">
                    Last updated: March 2026
                </p>

                {/* CONTENT BOX */}
                <div className="bg-card dark:bg-cardDark border border-borderLight dark:border-borderDark rounded-2xl p-6 md:p-8 space-y-6 text-textMain dark:text-textDark leading-relaxed">

                    <div>
                        <h2 className="font-semibold text-xl mb-2 text-titleLight dark:text-titleDark">
                            1. Information We Do Not Collect
                        </h2>
                        <p>We do not require login or collect personal data like name, email, or phone number.</p>
                    </div>

                    <div>
                        <h2 className="font-semibold text-xl mb-2 text-titleLight dark:text-titleDark">
                            2. Information You Provide
                        </h2>
                        <p>You may paste text which are temporarily stored for sharing.</p>
                    </div>

                    <div>
                        <h2 className="font-semibold text-xl mb-2 text-titleLight dark:text-titleDark">
                            3. How We Use Your Data
                        </h2>
                        <p>Your data is used only to generate a code and allow retrieval.</p>
                    </div>

                    <div>
                        <h2 className="font-semibold text-xl mb-2 text-titleLight dark:text-titleDark">
                            4. Data Storage & Expiry
                        </h2>
                        <ul className="list-disc ml-6">
                            <li>Temporary storage only</li>
                            <li>Auto delete after expiry</li>
                            <li>One-time view deletes data instantly</li>
                        </ul>
                    </div>

                    <div>
                        <h2 className="font-semibold text-xl mb-2 text-titleLight dark:text-titleDark">
                            5. Data Security
                        </h2>
                        <p>We use secure systems but avoid sharing sensitive data.</p>
                    </div>

                    <div>
                        <h2 className="font-semibold text-xl mb-2 text-titleLight dark:text-titleDark">
                            6. Third-Party Services
                        </h2>
                        <p>We use services like Firebase for storage.</p>
                    </div>

                    <div>
                        <h2 className="font-semibold text-xl mb-2 text-titleLight dark:text-titleDark">
                            7. Cookies
                        </h2>
                        <p>We use basic cookies for better experience.</p>
                    </div>

                    <div>
                        <h2 className="font-semibold text-xl mb-2 text-titleLight dark:text-titleDark">
                            8. Changes
                        </h2>
                        <p>We may update this policy anytime.</p>
                    </div>

                    <div>
                        <h2 className="font-semibold text-xl mb-2 text-titleLight dark:text-titleDark">
                            9. Contact
                        </h2>

                        <p className="mb-2 text-textMain dark:text-textDark">
                            If you have any questions, feedback, or need support, we are here to help.
                        </p>

                        <p>
                            You can reach out to us through our contact page.{" "}
                            <Link
                                to="/contact"
                                className="text-blue-600 hover:underline font-medium"
                            >
                                Click here
                            </Link>
                        </p>
                    </div>

                </div>

                {/* BACK BUTTON */}
                <div className="mt-16">
                    <Link
                        to="/"
                        className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-md transition"
                    >
                        ← Back to Home
                    </Link>
                </div>

                <Footer />

            </div>

        </section>
    );
}